<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Certificados Fitosanitarios</h4>

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCodigo">Código Solicitud</label>
                                    <input formControlName="Codigo" name="CodigoSolicitud" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpTipo">Tipo</label>
                                    <ng-select [items]="listTipoSolicitud"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoSolicitudEx"
                                               loadingText="Cargando..."
                                               [readonly]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                               [loading]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                               notFoundText="Tipo no encontrado"
                                               placeholder="-- Seleccione un Tipo --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" class="bu-dropdown" /> <svg-icon src="/assets/images/TipoSolicitudEx/Tipo-{{item.Id}}.svg" [svgStyle]="{ 'width.px':24 }"></svg-icon>
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" class="bu-dropdown" />
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Estado</label>
                                    <ng-select [items]="listEstado"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoSolicitudEx"
                                               loadingText="Cargando..."
                                               [readonly]="!listEstado || listEstado.length === 0"
                                               [loading]="!listEstado || listEstado.length === 0"
                                               notFoundText="Estado no encontrado"
                                               placeholder="-- Seleccione un Estado --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/EstadoSolicitud/EstadoSolicitudExport/{{item.Id}}.png" class="bu-dropdown" />
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/EstadoSolicitud/EstadoSolicitudExport/{{item.Id}}.png" class="bu-dropdown" />
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>

                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais">País Destino</label>
                                    <ng-select [items]="listPais"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPaisDestino"
                                               loadingText="Cargando..."
                                               [readonly]="!listPais || listPais.length === 0"
                                               [loading]="!listPais || listPais.length === 0"
                                               notFoundText="País no encontrado"
                                               placeholder="-- Seleccione un País --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Punto de Inspección</label>
                                    <ng-select [items]="listPuntoInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               loadingText="Cargando..."
                                               [readonly]="(!listPuntoInspeccion || listPuntoInspeccion.length === 0)"
                                               [loading]="(!listPuntoInspeccion || listPuntoInspeccion.length === 0)"
                                               notFoundText="Punto Inspección no encontrado"
                                               placeholder="-- Seleccione un Punto de Inspección --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpNifExportador">NIF Exportador</label>
                                    <input formControlName="NifExportador" name="NifExportador" title="" class="form-control" id="inpNifExportador" type="text" value="" maxlength="50">
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpNifImportador"> NIF Importador</label>
                                    <input formControlName="NifImportador" name="NifImportador" title="" class="form-control" id="inpNifImportador" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Estado Certificado Fitosanitario</label>
                                    <ng-select [items]="listEstadoCf"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoCf"
                                               loadingText="Cargando..."
                                               [readonly]="!listEstadoCf || listEstadoCf.length === 0"
                                               [loading]="!listEstadoCf || listEstadoCf.length === 0"
                                               notFoundText="Estado no encontrado"
                                               placeholder="-- Seleccione un Estado de CF --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/EstadoCertificadoFitoEx/{{item.Id}}.png" class="bu-dropdown" />
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/EstadoCertificadoFitoEx/{{item.Id}}.png" class="bu-dropdown" />
                                            <span class="bu-descripcion">{{item.Descripcion}}</span>
                                        </ng-template>

                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpNumeroCertificado">Nº Certificado Fitosanitario</label>
                                    <input formControlName="NumeroCertificado" name="NumeroCertificado" title="" class="form-control" id="inpNumeroCertificado" type="text" value="" maxlength="50">
                                </div>

                            </div>


                            <div class="row">

                                <!--<div class="form-group col-md-2">
                <label class="col-form-label" for="Utilizado">Utilizado</label>
                <p-toggleButton class="form-control-togglebutton" formControlName="Utilizado" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                offIcon="pi pi-times"></p-toggleButton>
            </div>
            <div class="form-group col-md-2">
                <label class="col-form-label" for="inpDescripcion">Disponible</label>
                <p-toggleButton class="form-control-togglebutton" formControlName="Disponible" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                offIcon="pi pi-times"></p-toggleButton>
            </div>-->

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFecha">Fecha desde</label>
                                    <p-calendar appendTo="body" formControlName="FechaDesde" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFecha">Fecha hasta</label>
                                    <p-calendar appendTo="body" formControlName="FechaHasta" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-xl-2 col-md-2">
                                    <label class="col-form-label" for="Utilizado">Utilizado</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Utilizado"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-xl-2 col-md-2">
                                    <label class="col-form-label" for="Disponible">Disponible</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Disponible"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <!--<div *ngIf="isCollapsed" class="form-group-0 float-left ui-fontgris">
                                        Pulse sobre "<i class="fa fa-caret-down"></i>" para desplegar los criterios de búsqueda
                                    </div>-->

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm " type="button" title="Realiza una búsqueda" (click)="onSearch($event)"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="resetForm($event)"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>




    </div>

</form>
